module.exports = __webpack_public_path__ + "img/laptop-ui-1.4553d1c6.jpg";